import apiFetch from '../apiFetch'

export default function (token, documentId, sheetId) {
  return apiFetch({ endPoint: `Document/${documentId}/ListFromSignRequest?sheetId=${sheetId}`, method: 'GET', token: token })
}
